import { render, staticRenderFns } from "./TheFAMISDBDashboard.vue?vue&type=template&id=e25f2b20&"
import script from "./TheFAMISDBDashboard.vue?vue&type=script&lang=js&"
export * from "./TheFAMISDBDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports